import React from "react";
import headerBg from "./assets/picOne.png";

const AccreditationCertification = () => {
  const consultancies = [
    "Training on Analysis of Reducing Sugar",
    "Conducting an Environmental Impact Assessment (EIA) and formulation of an Environmental Monitoring Plan (EMP)",
    "Training on Grain Grades and Standards",
    "Noise Pollution Assessment in Workplaces",
    "Reviewing Occupational Safety, Health and Environmental Management System Manual",
    "Conducting Air Quality Assessments in Workplaces",
    "Conducting a Study on Blending of Petrol",
    "Assessing Hygiene Level of Machine and Staff in the Factories",
    "Study on Concrete Mixing Ratios",
    "Assessing Water Quality of Borehole Water and Establishing Cause of Diarrhoea",
    "Assessment of Carbon Monoxide Levels in Workplaces",
    "Training Analysts on Testing of Matches",
    "Health Assessment Surveys",
    "Chemical Compatibility Study",
    "Training in Fertilizer Analysis",
    "Investigating Cause of Food Poisoning",
    "Assessment of Effects of Magnafloc 351 Powder on the Environment",
    "Conducting a Laboratory Audit",
    "Assessing Condition of Bottles to Determine their Usability"
  ];

  return (
    <div className="about-us">
      {/* === Header Section === */}
      <section
        className="about-header"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          height: "45vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div className="overlay">
          <h1 className="page-title">Consultancies</h1>
          <p className="subtitle">
            MBS provides specialized consultancies to support industry compliance, safety, and quality improvement.
          </p>
        </div>
      </section>

      {/* === Consultancies Table Section === */}
      <section
        className="consultancies-section"
        style={{ maxWidth: "1400px", margin: "50px auto", padding: "0 20px" }}
      >
        <p className="subtitle">Below is a list of all the consultancies available.</p>
        <table className="consultancies-table">
          <thead>
            <tr>
              <th>S/N</th>
              <th>Consultancy Title</th>
            </tr>
          </thead>
          <tbody>
            {consultancies.map((item, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{item}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>

      {/* === Inline CSS === */}
      <style>{`
        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 12px;
        }
        .page-title {
          font-size: 2.5rem;
          font-weight: bold;
          margin-bottom: 15px;
        }
        .subtitle {
          font-size: 1rem;
          margin-top: 5px;
          font-weight: 500;
        }

        .consultancies-section {
          line-height: 1.6;
        }

        .consultancies-table {
          width: 100%;
          border-collapse: collapse;
          margin-top: 20px;
          font-size: 1rem;
        }

        .consultancies-table th, .consultancies-table td {
          border: 1px solid #ddd;
          padding: 12px 15px;
          text-align: left;
        }

        .consultancies-table th {
          background-color: #ff6600;
          color: white;
          font-weight: 600;
        }

        .consultancies-table tbody tr {
          background-color: #fff;
          transition: all 0.3s ease;
        }

        .consultancies-table tbody tr:nth-child(even) {
          background-color: #f9f9f9;
        }

        .consultancies-table tbody tr:hover {
          background-color: #ffe5cc;
          transform: scale(1.02);
          box-shadow: 0 4px 12px rgba(0,0,0,0.1);
        }

        @media screen and (max-width: 768px) {
          .overlay { padding: 25px; }
          .page-title { font-size: 2rem; }
          .consultancies-table th, .consultancies-table td {
            padding: 10px 8px;
          }
        }
      `}</style>
    </div>
  );
};

export default AccreditationCertification;
